import React, { useState } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandGroup, CommandItem, CommandList, CommandInput, CommandEmpty } from "@/components/ui/command";

// Tag input: pick from suggestions OR add your own. value = array of strings (labels).
export function TagInput({ options = [], value = [], onChange, placeholder = "Add…", testId, maxLength }) {
  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);
  const add = (label) => {
    let v = (label || "").trim();
    if (!v) return;
    if (maxLength && v.length > maxLength) v = v.slice(0, maxLength);
    if (!value.some((x) => x.toLowerCase() === v.toLowerCase())) onChange([...value, v]);
    setText("");
  };
  const remove = (label) => onChange(value.filter((x) => x !== label));
  const suggestions = options.filter((o) => !value.some((v) => v.toLowerCase() === o.label.toLowerCase()));

  return (
    <div data-testid={testId}>
      <div className="flex gap-2">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <div className="flex-1">
              <Input
                value={text}
                onChange={(e) => { const v = maxLength ? e.target.value.slice(0, maxLength) : e.target.value; setText(v); setOpen(true); }}
                onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(text); } }}
                placeholder={placeholder}
                maxLength={maxLength}
                onFocus={() => setOpen(true)}
              />
            </div>
          </PopoverTrigger>
          <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start" onOpenAutoFocus={(e) => e.preventDefault()}>
            <Command>
              <CommandList>
                <CommandEmpty className="px-3 py-2 text-sm text-muted-foreground">Press Enter to add “{text}”</CommandEmpty>
                <CommandGroup className="max-h-52 overflow-auto">
                  {suggestions.filter((o) => o.label.toLowerCase().includes(text.toLowerCase())).slice(0, 30).map((o) => (
                    <CommandItem key={o.value} value={o.label} onSelect={() => { add(o.label); }}>{o.label}</CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        <button type="button" onClick={() => add(text)} className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-input bg-card hover:bg-secondary"><Plus className="h-4 w-4" /></button>
      </div>
      {value.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1.5">
          {value.map((v) => (
            <Badge key={v} variant="secondary" className="gap-1 bg-secondary">
              {v}
              <button type="button" onClick={() => remove(v)}><X className="h-3 w-3" /></button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
